module.exports = __webpack_public_path__ + "static/media/shop.bd26cad3.png";